module.exports = __webpack_public_path__ + "static/img/pexels--rahulshah--1042140.9987c97.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels--rahulshah--1042140.webp
// module id = NTxv
// module chunks = 0